import { VirtualElement } from '@floating-ui/react'
import { useState, useEffect, useRef } from 'react'

export function useIsTruncated(
    ref: React.RefObject<Element | VirtualElement | null>,
    setIsTruncatedCb?: (isTruncated: boolean) => void
) {
    const [isTruncated, setIsTruncated] = useState(false)
    const observer = useRef<ResizeObserver>()

    useEffect(() => {
        const el = ref.current
        if (!el) return

        // Exit early if not a real DOM element
        if (!(el instanceof HTMLElement)) return

        const checkTruncation = () => {
            const newIsTruncated = el.scrollWidth > el.clientWidth
            setIsTruncatedCb?.(newIsTruncated)
            setIsTruncated(newIsTruncated)
        }

        checkTruncation()

        observer.current = new ResizeObserver(checkTruncation)
        observer.current.observe(el)

        return () => {
            observer.current?.disconnect()
        }
    }, [ref, setIsTruncatedCb])

    return isTruncated
}
